//------------------
// is sheet details
//------------------
export default function isSheetDetails(tabId) {
  //-------------------
  // check tabId value
  //-------------------
  // console.log('----------------')
  // console.log('IN isSheetDetails')

  if (tabId == undefined) return false
  //
  switch (tabId.slice(0, 6)) {
    case 'skills':
      return true
    //----------------
    // return default
    //----------------
    default:
      return false
  }
}
